var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "main-footer bg-dark text-white pb-2" }, [
    _c(
      "div",
      { staticClass: "main-footer__map col-12 p-0 pb-2 d-none d-md-block" },
      [_c("div", { ref: "map", staticStyle: { "min-height": "25vh" } })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "main-footer__content text-center-xs row" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c("p", [
            _c("strong", [_vm._v(_vm._s(_vm.name))]),
            _c("br"),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.address) } }),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "tel:" + _vm.phone,
                  "data-ga-track": "",
                  "data-ga-category": "Phone",
                  "data-ga-action": "call",
                  "data-ga-label": _vm.phone
                }
              },
              [_vm._v(_vm._s(_vm.phone))]
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "mailto:" + _vm.email,
                  "data-ga-track": "",
                  "data-ga-category": "E-Mail",
                  "data-ga-action": "click",
                  "data-ga-label": _vm.email
                }
              },
              [_vm._v(_vm._s(_vm.email))]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.facebook.com/Custom-Architectural-Stone-515268391966681/",
                  target: "_blank",
                  "data-ga-track": "",
                  "data-ga-category": "Facebook",
                  "data-ga-action": "click"
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "svg-inline--fa fa-facebook-square fa-w-14",
                    attrs: {
                      width: "25px",
                      height: "25px",
                      "aria-hidden": "true",
                      "data-prefix": "fab",
                      "data-icon": "facebook-square",
                      role: "img",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 448 512"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "currentColor",
                        d:
                          "M448 80v352c0 26.5-21.5 48-48 48h-85.3V302.8h60.6l8.7-67.6h-69.3V192c0-19.6 5.4-32.9 33.5-32.9H384V98.7c-6.2-.8-27.4-2.7-52.2-2.7-51.6 0-87 31.5-87 89.4v49.9H184v67.6h60.9V480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
                      }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.instagram.com/customarchitecturalstone/",
                  target: "_blank",
                  "data-ga-track": "",
                  "data-ga-category": "Instagram",
                  "data-ga-action": "click"
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "svg-inline--fa fa-instagram fa-w-14",
                    attrs: {
                      width: "25px",
                      height: "25px",
                      "aria-hidden": "true",
                      "data-prefix": "fab",
                      "data-icon": "instagram",
                      role: "img",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 448 512"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "currentColor",
                        d:
                          "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c(
            "nav",
            [
              _c("menu-component", {
                attrs: { name: "footer", "list-class": "main-footer__list" }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _vm._v(
            "\n                Copyright © " +
              _vm._s(new Date().getFullYear()) +
              " - Powered by "
          ),
          _c(
            "a",
            { attrs: { href: "https://racerfish.com", target: "blank" } },
            [_vm._v("Racerfish")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f3621e4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f3621e4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/components/common/Footer.vue
// module id = 262
// module chunks = 17